import React, { Component } from "react";
import cn from "classnames";
import "./style.css";
import { times } from "ramda";
import Chart from "components/chart";
import Perlin from "loms.perlin";
import { ntds, hiv, malaria } from "data/indicators.json";

Perlin.seed(100);

const years = [1990, 2016, 2030];

const charts = [
  {
    ...ntds,
    title: "Prevalence of 15 NTDs",
    per: "per 100,000 people",
    data: ntds.currentForecast.map(d => d.value),
    good: ntds.ifWeProgress.map(d => d.value),
    bad: ntds.ifWeRegress.map(d => d.value),
  },
  {
    ...hiv,
    title: "New cases of HIV",
    per: "per 1,000 people",
    data: hiv.currentForecast.map(d => d.value),
    good: hiv.ifWeProgress.map(d => d.value),
    bad: hiv.ifWeRegress.map(d => d.value),
  },
  {
    ...malaria,
    title: "New cases of malaria",
    per: "per 1,000 people",
    data: malaria.currentForecast.map(d => d.value),
    good: malaria.ifWeProgress.map(d => d.value),
    bad: malaria.ifWeRegress.map(d => d.value),
  },
];

class Progress extends Component {
  constructor(props) {
    super(props);
    this.lines = [];
  }

  render() {
    const { headings = ["test", "test one"] } = this.props;
    return (
      <div
        id="progress"
        className={cn("progress", { "progress--isVisible": true })}
      >
        <div className="charts">
          {charts.map((chart, n) => (
            <Chart includeAxis={n === 0} {...chart} time={3000} offset={2000} />
          ))}
        </div>
      </div>
    );
  }
}

export default Progress;



// WEBPACK FOOTER //
// ./src/sections/progress/index.js